import _ from 'lodash';
import {AppName, getAppInst, getAppName} from "util/AppName"

export interface AppScope {
	persNr?: number
	date?: number
	dateEnd?: number
	costId?: string
}

/*************************************************************************************************
 * private
 *************************************************************************************************/

const lsPrefix = "SisAppScope_";

function getLocalStorageNameFor(app: AppName, appinst: string | null) {
	return lsPrefix + app + (appinst ? `*${appinst}` : '')
}

function getStore(lsName: string) {
	let ret;
	const item = localStorage.getItem(lsName);
	try {
		if (item) ret = JSON.parse(item);
	} catch (e) {
		//ignore
	}
	if (!_.isPlainObject(ret)) ret = {};
	return ret;
}

function saveStore(lsName: string, store: AppScope) {
	if (_.isEmpty(store)) {
		localStorage.removeItem(lsName);
	} else {
		localStorage.setItem(lsName, JSON.stringify(store));
	}
}

/*************************************************************************************************
 * public
 *************************************************************************************************/

/**
 * @param name {String} property name
 * @param [remove] {boolean} default=true, should get removed after first usage to
 *  prevent app from staying in that scope
 */
function getScope(name: keyof AppScope, remove: boolean = true) {
	if (!localStorage || !name) return;
	const lsName = getLocalStorageNameFor(getAppName(), getAppInst());
	let store = getStore(lsName);
	const ret = store[name];
	if (remove) store = _.omit(store, name);
	saveStore(lsName, store);
	return ret;
}

/**
 * @param app {String} app name
 * @param appinst {String} app instance name, if not given, the default appinst (null) is used
 * @param scope {{}} with parameters that are supported by the app
 */
function openScoped(app: AppName, appinst: string | null, scope: AppScope) {
	if (!localStorage || !app || !scope) return;
	const lsName = getLocalStorageNameFor(app, appinst);
	saveStore(lsName, scope);
	window.open(`./${app}.jsp${appinst ? '?appinst=' + encodeURIComponent(appinst) : ''}`, '_self');
}


export default {
	getScope: getScope,
	openScoped: openScoped,
};